'use client'

import React from 'react'
import { LiquidMetalButton } from '@/components/ui/liquid-metal-button'
import classes from './SectionHeader.module.css'

interface SectionHeaderProps {
  title: string
  href: string
  buttonLabel: string
  testId?: string
  /**
   * Strip the glass bar so the title + CTA sit directly on the page background.
   * Opt-in per instance (FeaturedProducts uses it; ShopByCategories keeps glass).
   */
  bare?: boolean
}

export const SectionHeader = ({
  title,
  href,
  buttonLabel,
  testId,
  bare = false,
}: SectionHeaderProps) => {
  return (
    <div className={bare ? `${classes.sectionHeader} ${classes.bare}` : classes.sectionHeader}>
      <h2 data-testid={testId} className={classes.title}>
        {title}
      </h2>
      {/* Liquid-metal CTA (Phase 5). SectionHeader is used only by the two
          homepage sections, so this is 2 WebGL contexts — safe alongside the
          lava background. Do not reuse SectionHeader on product-grid pages
          without switching to a CSS fallback. */}
      <LiquidMetalButton href={href} label={buttonLabel} variant="emerald" appearance="auto" />
    </div>
  )
}
